/**
 * FirmaPersonelSekmeleri.jsx — Firma Paneli personel listesi, SEKMELİ (backlog #357, backend #356).
 *
 * İki yerde AYNI bileşen:
 *   · pages/Firma/FirmaPersonelListPage.jsx                       (firma portalı — /Firma/Personel, her arayüz seti)
 *   · pages/Management/Modules/Firmalar/PersonelIncelemePage.jsx  (denetmen — Firma Detay › Personel Listesi)
 * `taraf` ("firma" | "denetmen") yalnızca kime hangi düğmenin çıkacağını ayırır; veri ve görünüm aynı.
 *
 * Beş sekme, hepsi TEK uçtan: GET /personnel/firma/{firmaId}/personel?sekme= (personelRosterService.getFirmaPersonelSekme)
 *   Tüm Personeller · Daimî Personeller · Geçici Personeller · İlişiği Kesilmişler · Tam Liste
 * Tüm Personeller'in (fuar seçiliyken) dört alt sekmesi — bir BÖLÜMLEME: Fuar Kadrosu + Onay Bekleyen + Görevlendirilmemiş = Tümü.
 * Sekme ve alt sekme rozetleri, arama ve sayfalama sunucudan; istemci hiçbir kümeyi kendisi kurmuyor.
 *
 * #511 (2026-10-19): etkin arayüz seti YABANCI KATILIMCI iken (`yabanciKatilimci` prop'u) liste SADE: Daimî / Geçici sekmesi yok, Tüm Personeller'de
 * alt sekme çubuğu yok, satırda çalışan tipi rozeti, kimlik doğrulama rozeti, belge sayaçları ve "kim ekledi" yok.
 * 2026-10-21 (Deniz'in beyaz tahta çizimi, Kişi Listesi'nin #531 ilkesi): sekmeler All Users · Assigned Users (Tüm Personeller'in Fuar Kadrosu alt
 * sekmesi, yalnızca fuar seçiliyken) · Ex-Employees (Tam Liste kalktı) ve satır YabanciKatilimciKarti.jsx — vesikalık + Kart Durumu hapı, ad ·
 * pasaport no · telefon, Pasaport + GDPR (SMS), firma adı + Çalışan (rengi fuar durumu) + Görevlendir / Görevlendirmeyi Kaldır, KKD. Diğer
 * arayüz setlerinin satırı eski kartıdır; ona yalnızca ortak parçalar geldi: fotoğraf + kart kararı rengi çerçeve/hap (şerit yalnızca Özel İzin) ve KKD karesi.
 * #704 (2026-11-03): Sade panel modu AÇIKKEN (`sadePanel` prop'u, FDS-Backend #703) her firma aynı SADE listeyi görür (üç sekme, kısa kart), ama
 * kartın belge yuvası firmanın KENDİ belgeleridir (eski kartın sütunu: yabancı firmada KVKK + kimlik / pasaport, Yerli'de PersonelBelgeKareleri
 * backend'in `gerekliBelgeler`iyle); GDPR + Pasaport kutuları ve gizli çalışan tipi yalnızca gerçek Yabancı Katılımcı'da (`yabanciKatilimci`).
 *
 * ─────────────────────────────────────────────────────────────────────────────────────
 * ESKİ "Daimî Liste" GÖRÜNÜMÜ BURADA YOK: o liste firmanın TÜM kadrosuydu, yani artık Tüm Personeller. (Yeni "Daimî
 * Personeller" bir ALT KÜME: SGK Hizmet Dökümü ile eklenen ya da elle Daimî işaretlenen.) FirmaDaimiListe.jsx ve
 * FirmaRosterPanel.jsx bu yüzden silindi; satır eylemleri (Sonlandır / Geri Al) PersonelRosterEylemleri.jsx'te kaldı.
 * ─────────────────────────────────────────────────────────────────────────────────────
 *
 * Satır = ROSTER satırı + sekme alanları (listede, kayitTuru, fuarDurumu, calisanTipi, ekleyen*, fuarSayisi…). Sekme satırı
 * `documents` / `cardEligible` / Eşleme ayrıntısı TAŞIMAZ. Eski Fuar Kadrosu kartının belge kareleri, köşe şeridi, sayaçları
 * ve "kim eşledi" satırı yine de gerekli olduğundan, görünen sayfadaki FUAR KADROSUNDAKİ satırlar (fuarDurumu KADRODA /
 * ONAY_BEKLIYOR ya da reddedilmiş Eşleme) için kişi başına `GET /personnel/firma/{firmaId}/{personId}?fuarId=` okunur
 * (sayfa başına en çok PAGE_SIZE, dört paralel, fuar+jeton başına önbellekli). Okuma gelene kadar satır ince kartla durur.
 *
 * Çalışan tipi (Daimî / Geçici / Belirsiz) satırda rozet; yazabilene rozetin kendisi açılır menü (PATCH calisan-tipi).
 * Yalnızca `listede` satırlarda — listede olmayan kişinin tipi yoktur (backend 404).
 *
 * İlişki bitişi: `IliskiBitisRozeti` / `iliskiBitisMeta` `aktif === false` olan HER satırı "sonlandırıldı" sayar, oysa listede
 * hiç yer almamış eski görevlendirme de `aktif: false` taşır. Bu yüzden onlara yalnızca `kayitTuru === ILISIGI_KESILMIS`
 * satırı verilir (bkz. bitisSatiri).
 */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  Card, CardBody, Row, Col, Button, Spinner, Alert, Input, Nav, NavItem, NavLink, Badge,
  Pagination, PaginationItem, PaginationLink,
  Modal, ModalHeader, ModalBody, ModalFooter,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from "reactstrap";
import {
  Search, Info, RefreshCw, Phone, Eye, UserPlus, UserMinus, AlertTriangle, ChevronDown, CheckCircle2, Clock, XCircle, ShieldCheck,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import {
  getFirmaPersonelSekme, setCalisanTipi, addToRoster, removeFromRoster, undoRosterEnding, answerEslesme,
  isRosterMissingError, iliskiBitisMeta, CALISAN_TIPI, PERSONEL_SEKME, PERSONEL_ALT_SEKME,
} from "../../services/personelRosterService";
import { assignPersonToFirmaAdmin, removeFromFuarCrew, getPersonelDetayAdmin } from "../../services/personnelAdminService";
import { uploadKisiFotograf } from "../../services/kisiKunyeService";
import { STATUS_HEX, NEUTRAL_GRAY, StatusTile } from "../Projects/StandPills";
import { PasaportIkonu, gdprDurumu, pasaportDurumu, durumRengi, yerliKimlikMi } from "./YabanciKatilimciParcalari";
import {
  PersonelAdBaglantisi, PersonelBelgeKareleri, PersonelSayacStack, IliskiBitisRozeti, KartKarariVesikalik, OzelIzinRibbon,
} from "./PersonelKartParcalari";
import {
  KimlikDogrulamaRozeti, EslesmeSatiri, EslesmeCevapDugmeleri, EslesmeRedModal,
} from "./PersonelDurumParcalari";
import {
  IliskiSonlandirModal, IliskiGeriAlModal, rosterSatirStili,
  KART_EYLEM_SUTUNU, KartGorevlendirDugmesi, KartSonlandirDugmesi, KartGeriAlDugmesi,
} from "./PersonelRosterEylemleri";
import PersonelEkleModal from "./PersonelEkleModal";
import { PanelDavetiDugmesi } from "./PanelDavetiModal";
import KimlikPasaportModal from "./KimlikPasaportModal";
import YabanciKatilimciKarti from "./YabanciKatilimciKarti";
import { etiketsizSertifikalar } from "./meslekler";
// #728: denetmen tarafı (Firma Detay › Personel Listesi) Kişi Listesi'nin kartını çizer.
import PersonelKart from "./PersonelKart";
import KimlikDogrulamaModal from "./KimlikDogrulamaModal";
import KartYazdirModal from "./KartYazdirModal";
import MeslekDuzenleModal from "./MeslekDuzenleModal";
import { sekmeSatiriniKisiyeCevir } from "./personelSekmeAdaptoru";
import FairContext from "../Contexts/Management/FairContext";
import SayfaBoyutuSecici from "../Common/SayfaBoyutuSecici";
import { VARSAYILAN_SAYFA_BOYUTU, sayfaBoyutuCozumle } from "../Common/sayfaBoyutu";

// Belge kareleri pahalı bir okuma gerektirdiği için firma sayfasındaki eski kadro boyutu (10) varsayılandır. #728: denetmen tarafında sayfa
// boyutu seçilir (10 · 25 · 50 · 100, SayfaBoyutuSecici); firma portalı hep varsayılanı kullanır.
const PAGE_SIZE = VARSAYILAN_SAYFA_BOYUTU;
// Vesikalık türleri: sunucudaki denetimin aynası (PNG / JPEG / WEBP); yanlış tür boşuna yüklenmesin.
const FOTO_TURLERI = /^image\/(jpeg|png|webp)$/i;
const FOTO_UZANTILARI = /\.(jpe?g|png|webp)$/i;
const DETAY_PARALEL = 4;

/** Üst sekmeler — sıra ve `sayilar` anahtarı. `fuarli`: alt sekme/fuarId bu sekmede anlamlı mı. */
const SEKMELER = [
  { key: PERSONEL_SEKME.TUM, label: "tum", title: "tumTitle", say: "tum", fuarli: true },
  { key: PERSONEL_SEKME.DAIMI, label: "daimi", title: "daimiTitle", say: "daimi", fuarli: true },
  { key: PERSONEL_SEKME.GECICI, label: "gecici", title: "geciciTitle", say: "gecici", fuarli: true },
  { key: PERSONEL_SEKME.ILISIGI_KESILMIS, label: "ilisigiKesilmis", title: "ilisigiKesilmisTitle", say: "ilisigiKesilmis", fuarli: false },
  { key: PERSONEL_SEKME.TAM, label: "tam", title: "tamTitle", say: "tam", fuarli: false },
];

/**
 * #511: Yabancı Katılımcı'da Daimî ve Geçici sekmeleri gösterilmez.
 * WAS (until the Yabancı Katılımcı card redo, 2026-10-21): the Tam Liste tab stayed; the three tabs are now All Users · Assigned Users ·
 * Ex-Employees (Deniz's whiteboard), so Tam Liste goes too.
 */
const sekmeGorunur = (s) => s.key === PERSONEL_SEKME.TUM || s.key === PERSONEL_SEKME.ILISIGI_KESILMIS;

/**
 * Yabancı Katılımcı'nın üç sekmesi. Her biri bir (sekme, alt sekme) çifti: "Assigned Users" ayrı bir backend sekmesi değil, Tüm
 * Personeller'in Fuar Kadrosu alt sekmesidir (yalnızca fuar seçiliyken; bu fuara görevlendirilmiş ya da eşlemesi onaylanmış kişiler).
 * Onay bekleyen (SAKA'nın eşlediği) kişi All Users'ta kalır: satırdaki sarı rol yazısı ve Onayla / Reddet düğmeleri onu söyler.
 */
const YK_SEKMELER = [
  { id: "tum", sekme: PERSONEL_SEKME.TUM, alt: PERSONEL_ALT_SEKME.TUMU, label: "yabanciKatilimci.sekmeTum", title: "yabanciKatilimci.sekmeTumTitle" },
  { id: "atanan", sekme: PERSONEL_SEKME.TUM, alt: PERSONEL_ALT_SEKME.KADRO, label: "yabanciKatilimci.sekmeAtanan", title: "yabanciKatilimci.sekmeAtananTitle", fuarli: true },
  { id: "eski", sekme: PERSONEL_SEKME.ILISIGI_KESILMIS, alt: PERSONEL_ALT_SEKME.TUMU, label: "yabanciKatilimci.sekmeEski", title: "yabanciKatilimci.sekmeEskiTitle" },
];

/** Tüm Personeller'in alt sekmeleri (fuar seçiliyken). `say` = sayilar.altSekmeler anahtarı. */
const ALT_SEKMELER = [
  { key: PERSONEL_ALT_SEKME.TUMU, label: null, title: null, say: "tumu" },
  { key: PERSONEL_ALT_SEKME.KADRO, label: "altKadro", title: "altKadroTitle", say: "kadro" },
  { key: PERSONEL_ALT_SEKME.GOREVLENDIRILMEMIS, label: "altGorevlendirilmemis", title: "altGorevlendirilmemisTitle", say: "gorevlendirilmemis" },
  { key: PERSONEL_ALT_SEKME.ONAY_BEKLEYEN, label: "altOnayBekleyen", title: "altOnayBekleyenTitle", say: "onayBekleyen" },
];

const BOS_VERI = {
  records: [], total: 0, totalPages: 1, sayilar: null, fuarCanli: null, iliskiSonlandirabilir: true,
};

/** Çalışan tipi → rozet (id 0 = Belirsiz). Renkler sabit hex: bu temada `success`/`secondary` sınıfları güvenilmez. */
const TIP_META = {
  1: { label: "tipDaimi", hex: "#405189" },
  2: { label: "tipGecici", hex: "#299cdb" },
  0: { label: "tipBelirsiz", hex: NEUTRAL_GRAY },
};
const tipId = (calisanTipi) => (calisanTipi === CALISAN_TIPI.DAIMI || calisanTipi === CALISAN_TIPI.GECICI ? calisanTipi : 0);

/** Fuar durumu (`fuarDurumu`, yalnızca fuar seçiliyken gelir) → rozet. */
const FUAR_DURUMU_META = {
  KADRODA: { label: "altKadro", hex: STATUS_HEX.success, Icon: CheckCircle2 },
  ONAY_BEKLIYOR: { label: "onayBekliyor", hex: STATUS_HEX.warning, Icon: Clock },
  GOREVLENDIRILMEMIS: { label: "altGorevlendirilmemis", hex: NEUTRAL_GRAY, Icon: null },
};

function tarihYaz(value) {
  if (!value) return null;
  const d = new Date(String(value).replace(" ", "T"));
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleDateString(i18n.language === "en" ? "en-GB" : "tr-TR");
}

/** Satır bu fuarın kadrosunda mı (belge/Eşleme ayrıntısı okunabilir mi)? Reddedilmiş Eşleme de kadro satırı olarak kalır. */
export const kadroSatiri = (row) => row.fuarDurumu === "KADRODA" || row.fuarDurumu === "ONAY_BEKLIYOR" || row.eslesmeReddedildi === true;

/** `IliskiBitisRozeti` / `rosterSatirStili` için: yalnızca gerçekten ilişiği kesilmiş satır; öteki satırlar için null. */
const bitisSatiri = (row) => (row.kayitTuru === "ILISIGI_KESILMIS" ? row : null);

// ─── Küçük parçalar ──────────────────────────────────────────────────────────────────

function CalisanTipiRozeti({ row, degistirilebilir, busy, onSec }) {
  const { t } = useTranslation("components");
  const tip = tipId(row.calisanTipi);
  const meta = TIP_META[tip];
  const kaynak = row.calisanTipiKaynagi === 1
    ? t("personelSekmeler.tipBelge")
    : row.calisanTipiKaynagi === 2 ? t("personelSekmeler.tipElle") : null;
  const baslik = [kaynak, row.calisanTipiDegistirenAdi, tarihYaz(row.calisanTipiTarihi)].filter(Boolean).join(" · ");
  const sinif = "badge fw-normal text-white d-inline-flex align-items-center gap-1";

  if (!degistirilebilir) {
    return <span className={sinif} style={{ backgroundColor: meta.hex }} title={baslik || undefined}>{t(`personelSekmeler.${meta.label}`)}</span>;
  }
  // #729: eski görevlendirmenin (ESKI_KAYIT) aktif liste satırı yok — Belirsiz'e geri dönülemez, Daimî / Geçici seçmek kişiyi firmanın listesine ekler.
  const listeyeEkle = row.kayitTuru === "ESKI_KAYIT";
  return (
    <UncontrolledDropdown>
      <DropdownToggle
        tag="span" role="button" tabIndex={0} className={sinif} disabled={busy}
        style={{ backgroundColor: meta.hex, cursor: "pointer" }}
        title={[baslik, t(listeyeEkle ? "personelSekmeler.tipListeyeEkleBilgi" : "personelSekmeler.tipDegistir")].filter(Boolean).join(" — ")}
      >
        {t(`personelSekmeler.${meta.label}`)}<ChevronDown size={11} />
      </DropdownToggle>
      <DropdownMenu container="body">
        {(listeyeEkle ? [CALISAN_TIPI.DAIMI, CALISAN_TIPI.GECICI] : [CALISAN_TIPI.DAIMI, CALISAN_TIPI.GECICI, 0]).map((v) => (
          <DropdownItem key={v} active={tip === v} disabled={tip === v} onClick={() => onSec(row, v === 0 ? null : v)}>
            {listeyeEkle
              ? t("personelSekmeler.tipListeyeEkleSec", { tip: t(`personelSekmeler.${TIP_META[v].label}`) })
              : t(`personelSekmeler.${TIP_META[v].label}`)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

// WAS (until 2026-10-21): a `yabanciKatilimci` param swapped "Fair Roster" for a plain "Assigned" (#511); the Yabancı Katılımcı card
// (YabanciKatilimciKarti) now says the status with the colour of its role label, so this badge is only drawn on the other lists.
function FuarDurumuRozeti({ row }) {
  const { t } = useTranslation("components");
  const meta = FUAR_DURUMU_META[row.fuarDurumu];
  if (!meta) return null;
  const { Icon } = meta;
  return (
    <>
      <span className="badge fw-normal text-white d-inline-flex align-items-center gap-1" style={{ backgroundColor: meta.hex }}>
        {Icon && <Icon size={12} />}{t(`personelSekmeler.${meta.label}`)}
      </span>
      {row.eslesmeReddedildi && (
        <span className="badge fw-normal text-white d-inline-flex align-items-center gap-1" style={{ backgroundColor: STATUS_HEX.danger }}>
          <XCircle size={12} />{t("personelSekmeler.eslesmeReddedildi")}
        </span>
      )}
    </>
  );
}

/** Bilgi sütununun küçük satırları: kim ekledi · kaç fuar / son fuar · eski kayıt. `ekleyenGizli`: Yabancı Katılımcı "kim ekledi" görmez (#511). */
function SatirNotlari({ row, fuarBilgisi, ekleyenGizli = false }) {
  const { t } = useTranslation("components");
  const ekleyen = row.ekleyenAdi && !ekleyenGizli
    ? t(row.ekleyenSaka ? "personelSekmeler.sakaEkledi" : "personelSekmeler.ekledi", { ad: row.ekleyenAdi })
    : null;
  const son = row.sonFuarId
    ? t("personelSekmeler.sonFuar", { tarih: tarihYaz(row.sonFuarTarihi) || `#${row.sonFuarId}` })
    : null;
  const fuarSatiri = fuarBilgisi ? [t("personelSekmeler.fuarSayisi", { sayi: row.fuarSayisi ?? 0 }), son].filter(Boolean).join(" · ") : null;
  // #620: each note keeps its line (ellipsis, full text on hover).
  return (
    <>
      {ekleyen && <div className="text-muted text-truncate" style={{ fontSize: "0.75rem" }} title={ekleyen}>{ekleyen}</div>}
      {fuarSatiri && <div className="text-muted text-truncate" style={{ fontSize: "0.75rem" }} title={fuarSatiri}>{fuarSatiri}</div>}
    </>
  );
}

// ─── Kart ────────────────────────────────────────────────────────────────────────────

/**
 * #704: the company's OWN document squares for the sade card's document slot while Sade panel modu is ON: the same column the old card
 * draws below (a foreign company: KVKK + kimlik / pasaport; a Yerli one: PersonelBelgeKareleri with the backend's `gerekliBelgeler`), without
 * the KKD square, which the sade card draws in its own slot.
 */
function KendiBelgeKareleri({ dto, row, yabanci, pasaportAcik, onBelge, onKimlik }) {
  const { t } = useTranslation("components");
  // #704 (Deniz, 2026-11-03): the same captioned squares the Yabancı Katılımcı row draws (a coloured square, its name under it), not grey badges
  // and an outline button. The square is the upload entry too: a click opens the ID / passport window, as the Yabancı Katılımcı's passport square does.
  // WAS (until this pass): two <Badge>s ("KVKK" green/gray, "Kimlik / Pasaport" by status) plus a primary-outline <Button> "Kimlik / Pasaport"
  // for taraf === "firma"; the Yerli branch drew PersonelBelgeKareleri as one uncaptioned line with dividers.
  if (yabanci) {
    const kvkk = gdprDurumu(dto);
    const kimlik = pasaportDurumu(dto, row.kimlikDogrulamaDurum);
    return (
      <div className="d-flex align-items-start gap-3">
        <StatusTile
          icon={ShieldCheck} background={durumRengi(kvkk)} label={t(`yabanciKatilimci.gdprIpucu.${kvkk}`)}
          caption={t("personelSekmeler.kvkk")} onClick={() => onBelge(row, "kvkk")}
        />
        <StatusTile
          icon={PasaportIkonu} background={durumRengi(kimlik)} label={t(`yabanciKatilimci.${yerliKimlikMi(dto) ? "kimlikIpucu" : "pasaportIpucu"}.${kimlik}`)}
          caption={t("personelSekmeler.kimlikPasaport")} onClick={pasaportAcik ? () => onKimlik(row, dto) : undefined}
        />
      </div>
    );
  }
  // Yerli: the sections the Kişi Listesi card places (KVKK · SGK İSG Sağlık · Meslek · Firma), each square captioned, with the room the
  // Yabancı Katılımcı's tiles have between them. The KKD square is the card's own slot, so no "diger" section here.
  const kareler = {
    documents: dto.documents,
    gerekliBelgeler: dto.gerekliBelgeler,
    kvkkDijitalOnay: dto.kvkkDijitalOnay,
    firmaBelgeleriStatus: dto.firmaBelgeleriStatus,
    onDocClick: (key) => onBelge(row, key),
    meslekiEgitimler: dto.meslekiEgitimler,
    etiketsizBelgeler: etiketsizSertifikalar(dto).length,
    personId: row.personId,
    etiketli: true,
  };
  // Seen live (1440 px): in one line the six squares + company block + KKD do not fit beside the name, so the slot is two lines of the same
  // height as the photo - KVKK + SGK İSG Sağlık over Meslek + Firma - the width of four squares (4 x 40 + 3 x 8 gaps = 184, 190 allowed).
  return (
    <div className="d-flex flex-wrap align-items-start gap-2" style={{ maxWidth: 190 }}>
      <PersonelBelgeKareleri {...kareler} bolum="kvkk" />
      <PersonelBelgeKareleri {...kareler} bolum="kisisel" />
      <PersonelBelgeKareleri {...kareler} bolum="mesleki" />
      {dto.firmaBelgeleriStatus !== undefined && <PersonelBelgeKareleri {...kareler} bolum="firma" />}
    </div>
  );
}

// WAS (until #704): function PersonelSekmeKarti({ row, taraf, yazabilir, yabanci, yabanciKatilimci, firmaGorunenAdi, ...
function PersonelSekmeKarti({
  row, taraf, yazabilir, yabanci, yabanciKatilimci, sade = yabanciKatilimci, firmaGorunenAdi, fuarId, fuarBilgisi, detay, busy, iliskiSonlandirabilir,
  adBaglantisi, detayAcik, onDetay, onBelge, onKimlik, fotoYukleniyor, onFoto,
  onTip, onGorevlendir, onSonlandir, onGeriAl, onOnayla, onReddet, onFuardanCikar,
  firmaId, firmaAdi, geriEtiketi, onKimlikDogrula, onKartYazdir, onMeslek,
}) {
  const { t } = useTranslation("components");
  const dto = detay?.durum === "hazir" ? detay.dto : null;
  const bitis = bitisSatiri(row);
  const bitisBilgisi = iliskiBitisMeta(bitis);
  const dim = rosterSatirStili(bitis);
  const cevaplanabilir = taraf === "firma" && yazabilir && Boolean(fuarId) && (
    row.fuarDurumu === "ONAY_BEKLIYOR" || (row.fuarDurumu === "GOREVLENDIRILMEMIS" && row.eslesmeReddedildi === true)
  );
  const gorevlendirilebilir = yazabilir && Boolean(fuarId) && row.listede && row.fuaraAtanabilir
    && row.fuarDurumu === "GOREVLENDIRILMEMIS" && row.eslesmeReddedildi !== true;
  const sonlandirilabilir = yazabilir && iliskiSonlandirabilir && row.kayitTuru === "LISTEDE" && row.sonlandirilabilir !== false;
  const geriAlinabilir = yazabilir && row.kayitTuru === "ILISIGI_KESILMIS" && row.geriAlinabilir === true;
  const fuardanCikarilabilir = taraf === "denetmen" && yazabilir && Boolean(fuarId)
    && (row.fuarDurumu === "KADRODA" || row.fuarDurumu === "ONAY_BEKLIYOR");
  // #729: eski görevlendirme (ESKI_KAYIT) de tıklanır — seçim kişiyi firmanın listesine ekler; sonlandırılmış ilişki tıklanmaz (Geri al yolu).
  const tipDegistirilebilir = yazabilir && (row.listede === true || row.kayitTuru === "ESKI_KAYIT");
  // #588: firma portalında vesikalık kutusu = fotoğraf yükleme düğmesi. Backend: PERSONEL yazma + aktif kadro satırı; kimliği SAKA'ca doğrulanmış
  // kişide firmaya 403 KIMLIK_DOGRULANMIS verir → #726: o kişide kutu düz bir fotoğraftır (tıklanmaz, yazı da çıkmaz).
  // WAS (until #726): `fotoKilitli` kutunun başlığına "fotoğrafı yalnızca SAKA değiştirebilir" eklerdi.
  const fotoYuklenebilir = taraf === "firma" && yazabilir && row.kayitTuru === "LISTEDE";
  const fotoIslemi = fotoYuklenebilir && row.kimlikDogrulamaDurum !== 1 ? (dosya) => onFoto(row, dosya) : undefined;
  // Kadro satırının belge/Eşleme ayrıntısı henüz okunmadı (sayfa başına kişi başına okunuyor, bkz. ana bileşen).
  const detayBekleniyor = kadroSatiri(row) && Boolean(fuarId) && !dto;
  // Sekme satırında ad/soyad boş olabilir (adsız kayıt); kadro ayrıntısı geldiyse oradaki ad kullanılır.
  const ad = `${row.ad ?? ""} ${row.soyad ?? ""}`.trim() || `${dto?.name ?? ""} ${dto?.surname ?? ""}`.trim() || "—";

  // Yabancı Katılımcı: Deniz'in beyaz tahta çizimine göre kısaltılmış kart (YabanciKatilimciKarti.jsx). Burada hook yok — erken dönüş güvenli.
  // #704: Sade panel modunda her firma bu kartı alır; belge yuvası yalnızca gerçek Yabancı Katılımcı'da GDPR + Pasaport, öbürlerinde kendi belgeleri.
  // WAS (until #704): if (yabanciKatilimci) {
  if (sade) {
    return (
      <YabanciKatilimciKarti
        // undefined = the Yabancı Katılımcı's own boxes; null = nothing (no detail read for this row, as the old card draws nothing then)
        belgeler={yabanciKatilimci ? undefined : dto ? (
          <KendiBelgeKareleri
            dto={dto} row={row} yabanci={yabanci} pasaportAcik={taraf === "firma" && yazabilir && !bitis}
            onBelge={onBelge} onKimlik={onKimlik}
          />
        ) : null}
        row={row} dto={dto} ad={ad} firmaGorunenAdi={firmaGorunenAdi} fuarId={fuarId} busy={busy} dim={dim}
        bitis={bitis} bitisBilgisi={bitisBilgisi}
        notlar={<SatirNotlari row={row} fuarBilgisi={fuarBilgisi} ekleyenGizli />}
        detayBekleniyor={detayBekleniyor} detayHata={detay?.durum === "hata"}
        adBaglantisi={adBaglantisi} detayAcik={detayAcik} onDetay={() => onDetay(row)}
        cevaplanabilir={cevaplanabilir} gorevlendirilebilir={gorevlendirilebilir}
        // Görevlendirmeyi Kaldır: yalnızca fuar kadrosundakiler (KADRODA). Onay bekleyen kişi için Reddet var — cevap kaydedilir.
        gorevKaldirilabilir={yazabilir && Boolean(fuarId) && row.fuarDurumu === "KADRODA"}
        sonlandirilabilir={sonlandirilabilir} geriAlinabilir={geriAlinabilir}
        onFoto={fotoIslemi} fotoYukleniyor={fotoYukleniyor}
        // Pasaport yazma uçları sonlanmış ilişkide 403 verir → tıklanamaz.
        pasaportAcik={taraf === "firma" && yazabilir && !bitis}
        onPasaport={() => onKimlik(row, dto)} onGorevlendir={() => onGorevlendir(row)} onGorevKaldir={() => onFuardanCikar(row)}
        onOnayla={() => onOnayla(row)} onReddet={() => onReddet(row)}
        onSonlandir={() => onSonlandir(row)} onGeriAl={() => onGeriAl(row)}
      />
    );
  }

  // #728: denetmen (Firma Detay › Personel Listesi) Kişi Listesi'nin kartını (#531) çizer: çerçeve ve "Kart Yazdır" rengi = kart kararı, başlıklı belge
  // grupları, Özel İzin şeridi, firma + rol, Meslek. Satır ile ayrıntı okuması `sekmeSatiriniKisiyeCevir`le o kartın okuduğu biçime çevrilir; sekmeye
  // özgü işler (çalışan tipi, kim ekledi, ilişki bitişi, Fuara Görevlendir / Fuardan Çıkar / İlişkiyi Sonlandır / Geri Al) kartın iki ek yuvasında durur.
  // Ayrıntısı okunmamış satır (kadroda olmayan) ince kalır: belge kareleri nötr gri, karar "bilinmiyor". WAS (until #728): aşağıdaki firma kartı
  // denetmende de çizilirdi.
  if (taraf === "denetmen") {
    const kisi = sekmeSatiriniKisiyeCevir({ row, dto, firmaId, firmaAdi, fuarId });
    return (
      <PersonelKart
        person={kisi} fuarId={fuarId} kartFuarId={fuarId}
        soluk={Boolean(dim)} geriEtiketi={geriEtiketi}
        onKimlik={() => onKimlikDogrula(kisi)}
        onDetay={detayAcik ? () => onDetay(row) : undefined}
        onKartYazdir={() => onKartYazdir(kisi)}
        onMeslek={() => onMeslek(kisi)}
        ekRozetler={(
          <>
            <div className="d-flex align-items-center gap-1 flex-wrap mt-1">
              <CalisanTipiRozeti row={row} degistirilebilir={tipDegistirilebilir} busy={busy} onSec={onTip} />
              {row.kayitTuru === "ESKI_KAYIT" && (
                <Badge color="light" className="text-body border fw-normal" title={t("personelSekmeler.listedeDegilTitle")}>
                  {t("personelSekmeler.listedeDegil")}
                </Badge>
              )}
              <IliskiBitisRozeti record={bitis} />
            </div>
            {bitis && (
              <div className="small text-muted mt-1" style={{ whiteSpace: "normal" }}>
                {[bitisBilgisi.tarih, bitisBilgisi.bitirenAdi, bitisBilgisi.kaynakAdi].filter(Boolean).join(" · ")}
                {bitisBilgisi.sebep && <span className="fst-italic"> — {bitisBilgisi.sebep}</span>}
              </div>
            )}
            <SatirNotlari row={row} fuarBilgisi={fuarBilgisi} />
            {dto && <EslesmeSatiri record={dto} className="mt-2" />}
          </>
        )}
        ekEylemler={(
          <>
            {gorevlendirilebilir && (
              <KartGorevlendirDugmesi
                tam disabled={busy} onClick={() => onGorevlendir(row)}
                title={t("personelSekmeler.fuarIcinGorevlendir", { fuarId })}
              />
            )}
            {/* #647: SMS ile geçici kişi paneline davet (backend #644). Yazma yetkisi olana; sonlanmış ilişkide yok. */}
            {yazabilir && Boolean(row.personId) && row.kayitTuru !== "ILISIGI_KESILMIS" && (
              <PanelDavetiDugmesi personId={row.personId} adSoyad={ad} className="w-100" />
            )}
            {fuardanCikarilabilir && (
              <Button
                color="danger" outline size="sm" className="w-100" disabled={busy}
                title={t("personelSekmeler.fuardanCikarTitle")} onClick={() => onFuardanCikar(row)}
              >
                <UserMinus size={14} className="me-1" />{t("personelSekmeler.fuardanCikar")}
              </Button>
            )}
            {sonlandirilabilir && <KartSonlandirDugmesi disabled={busy} onClick={() => onSonlandir(row)} />}
            {geriAlinabilir && <KartGeriAlDugmesi disabled={busy} onClick={() => onGeriAl(row)} />}
          </>
        )}
      />
    );
  }

  // Özel İzin şeridi YALNIZCA verilmiş izinde (#531'in ilkesi); kart kararı vesikalığın çerçevesinde ve hapında. WAS (until 2026-10-21): köşede
  // üç durumlu "Kart Alabilir" şeridi (PersonelKartRibbon) ve fotoğrafsız siyah çerçeveli kutu.
  const ozelIzin = dto?.singlePermit || null;

  return (
    <Card className="mb-3 position-relative overflow-hidden">
      {ozelIzin && <OzelIzinRibbon izin={ozelIzin} />}
      <CardBody className={ozelIzin ? "pt-4" : undefined}>
        <Row className="align-items-center g-3">
          <Col md="auto" style={dim}>
            <KartKarariVesikalik
              person={row} dto={dto} serit={Boolean(ozelIzin)} portal={taraf === "firma"}
              onFoto={fotoIslemi} fotoYukleniyor={fotoYukleniyor}
            />
          </Col>

          {/* #620: name / ID number / phone keep their line (ellipsis, full text on hover) so a long name does not change the row's spacing. */}
          <Col md={3} style={{ minWidth: 0 }}>
            <div style={dim}>
              <div className="fw-bold fs-5 text-truncate" title={ad}>
                {adBaglantisi ? (
                  <PersonelAdBaglantisi href={adBaglantisi.href} onGit={adBaglantisi.onGit}>{ad}</PersonelAdBaglantisi>
                ) : ad}
              </div>
              <div className="text-muted small text-truncate" title={row.tcNo || row.kimlikNo || undefined}>{row.tcNo || row.kimlikNo || "—"}</div>
              {row.telefon && (
                <div className="text-muted d-flex align-items-center gap-1" style={{ fontSize: "0.75rem" }} title={t("personelSekmeler.iletisim", { telefon: row.telefon })}>
                  <Phone size={11} className="flex-shrink-0" /><span className="text-truncate">{t("personelSekmeler.iletisim", { telefon: row.telefon })}</span>
                </div>
              )}
              <SatirNotlari row={row} fuarBilgisi={fuarBilgisi} />
            </div>
            <div className="d-flex align-items-center gap-1 flex-wrap mt-1">
              {row.yasakli && <span className="badge bg-danger fw-normal">{t("personelSekmeler.girisiYasakli")}</span>}
              {row.kayitTuru === "ESKI_KAYIT" && (
                <Badge color="light" className="text-body border fw-normal" title={t("personelSekmeler.listedeDegilTitle")}>
                  {t("personelSekmeler.listedeDegil")}
                </Badge>
              )}
              <IliskiBitisRozeti record={bitis} />
            </div>
            {bitis && (
              <div className="small text-muted mt-1" style={{ whiteSpace: "normal" }}>
                {[bitisBilgisi.tarih, bitisBilgisi.bitirenAdi, bitisBilgisi.kaynakAdi].filter(Boolean).join(" · ")}
                {bitisBilgisi.sebep && <span className="fst-italic"> — {bitisBilgisi.sebep}</span>}
              </div>
            )}
            {dto && <EslesmeSatiri record={dto} className="mt-2" />}
          </Col>

          {/* Rol sütunu: çalışan tipi · kimlik doğrulama · fuar durumu · (yeşil Fuara Görevlendir). */}
          <Col md="auto" style={{ minWidth: 172 }} className="d-flex flex-column align-items-start gap-2">
            <CalisanTipiRozeti row={row} degistirilebilir={tipDegistirilebilir} busy={busy} onSec={onTip} />
            <KimlikDogrulamaRozeti durum={row.kimlikDogrulamaDurum} />
            <div className="d-flex flex-column align-items-start gap-1">
              <FuarDurumuRozeti row={row} />
            </div>
            {gorevlendirilebilir && (
              <KartGorevlendirDugmesi
                disabled={busy}
                onClick={() => onGorevlendir(row)}
                title={t("personelSekmeler.fuarIcinGorevlendir", { fuarId })}
              />
            )}
          </Col>

          <Col>
            {detayBekleniyor && (
              detay?.durum === "hata"
                ? <span className="small text-muted">{t("personelSekmeler.belgeOkunamadi")}</span>
                : <span className="small text-muted d-inline-flex align-items-center gap-2"><Spinner size="sm" color="secondary" />{t("personelSekmeler.belgeOkunuyor")}</span>
            )}
            {dto && (yabanci ? (
              // #320: yabancı firmada diğer belgeler istenmez — yalnızca KVKK ve kimlik / pasaport.
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <Badge
                  color={dto.documents?.kvkk?.status === 1 || dto.kvkkDijitalOnay?.tamam ? "success" : "secondary"}
                  role="button" onClick={() => onBelge(row, "kvkk")}
                >
                  {t("personelSekmeler.kvkk")}
                </Badge>
                <Badge color={dto.documents?.kimlikFotografi?.status === 1 ? "success"
                  : dto.documents?.kimlikFotografi?.status === 2 ? "danger"
                  : dto.documents?.kimlikFotografi?.status === 0 ? "warning" : "secondary"}>
                  {t("personelSekmeler.kimlikPasaport")}
                </Badge>
                {taraf === "firma" && (
                  <Button size="sm" color="primary" outline onClick={() => onKimlik(row, dto)}>
                    {t("personelSekmeler.kimlikPasaport")}
                  </Button>
                )}
              </div>
            ) : (
              <PersonelBelgeKareleri
                documents={dto.documents}
                gerekliBelgeler={dto.gerekliBelgeler}
                kvkkDijitalOnay={dto.kvkkDijitalOnay}
                firmaBelgeleriStatus={dto.firmaBelgeleriStatus}
                onDocClick={(key) => onBelge(row, key)}
                meslekiEgitimler={dto.meslekiEgitimler}
                etiketsizBelgeler={etiketsizSertifikalar(dto).length}
                personId={row.personId}
                // KKD karesi (Deniz'in Kişi Listesi ilkesinin firma listelerine gelen parçası, 2026-10-21): rengi `kkd.durum`dan; `kkd` yoksa düz gri.
                kkd={dto.kkd ?? null}
              />
            ))}
          </Col>

          <Col md="auto" className="d-flex align-items-center gap-3 ms-auto mt-2 mt-md-0">
            {dto && <PersonelSayacStack counts={dto.statusCounts} href={adBaglantisi?.href} />}
            <div className="d-flex flex-column align-items-stretch gap-1" style={KART_EYLEM_SUTUNU}>
              {cevaplanabilir && (
                <EslesmeCevapDugmeleri
                  record={{ eslesmeTipi: 2, eslesmeDurumu: row.fuarDurumu === "ONAY_BEKLIYOR" ? 0 : 2 }}
                  busy={busy}
                  onOnayla={() => onOnayla(row)}
                  onReddet={() => onReddet(row)}
                />
              )}
              {detayAcik && (
                <Button color="info" outline size="sm" className="w-100" onClick={() => onDetay(row)}>
                  <Eye size={14} className="me-1" />{t("personelSekmeler.detaylar")}
                </Button>
              )}
              {/* #647: SMS ile geçici kişi paneline davet (backend #644). Yazma yetkisi olana (denetmen ya da portal.personel.manage'li firma); sonlanmış ilişkide yok. */}
              {yazabilir && Boolean(row.personId) && row.kayitTuru !== "ILISIGI_KESILMIS" && (
                <PanelDavetiDugmesi personId={row.personId} adSoyad={ad} className="w-100" />
              )}
              {fuardanCikarilabilir && (
                <Button
                  color="danger" outline size="sm" className="w-100" disabled={busy}
                  title={t("personelSekmeler.fuardanCikarTitle")} onClick={() => onFuardanCikar(row)}
                >
                  <UserMinus size={14} className="me-1" />{t("personelSekmeler.fuardanCikar")}
                </Button>
              )}
              {sonlandirilabilir && <KartSonlandirDugmesi disabled={busy} onClick={() => onSonlandir(row)} />}
              {geriAlinabilir && <KartGeriAlDugmesi disabled={busy} onClick={() => onGeriAl(row)} />}
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

// ─── Sekme çubukları ─────────────────────────────────────────────────────────────────

function Rozet({ secili, sayi, hex = NEUTRAL_GRAY }) {
  if (sayi == null) return null;
  return (
    <span
      className={`badge ms-1 ${secili ? "bg-light text-body" : "text-white"}`}
      style={secili ? undefined : { backgroundColor: hex }}
    >
      {sayi}
    </span>
  );
}

// ─── Ana bileşen ─────────────────────────────────────────────────────────────────────

/**
 * @param firmaId        listenin firması (firma portalında oturumdaki firma, denetmende Firma Detay'ın firması)
 * @param firmaAdi       "Personel Ekle" penceresinde gösterilir (denetmen); firma portalında null
 * @param fuarId         üst çubuktaki seçili fuar; yoksa alt sekmeler ve fuar durumu rozetleri çıkmaz
 * @param taraf          "firma" | "denetmen"
 * @param yazabilir      yazma düğmeleri (Personel Ekle, görevlendir, sonlandır, tip, Onayla/Reddet) — firma portalında
 *                       PERSONEL modülünün seviyesi WRITE ve üstü mü; denetmende hep true
 * @param yabanci        yabancı firma — belge kareleri yerine KVKK + kimlik / pasaport
 * @param yabanciKatilimci  #511: etkin arayüz seti Yabancı Katılımcı — SADE görünüm: All Users · Assigned Users · Ex-Employees sekmeleri, alt sekme
 *                       çubuğu yok (kim onay bekliyor / görevli / değil "Çalışan" yazısının renginden okunur), Daimî / Geçici ve "kim ekledi" yok,
 *                       satır YabanciKatilimciKarti, "İlişkiyi Sonlandır" sönük bir bağlantı. `yabanci` zaten true'dur.
 * @param firmaGorunenAdi  Yabancı Katılımcı satırında "Çalışan" yazısının üstünde duran firma adı (oturumdaki firmanın kendi adı)
 * @param baslangicSekme / baslangicAltSekme   ilk açılan sekme (`?sekme=` / `?alt=` bağlantıları için)
 * @param reloadToken    üst sayfanın "yeniden oku" sayacı
 * @param detayOf        (row) => { href, onGit } | null — kişinin detayı; null ise "Detaylar" ve ad bağlantısı çıkmaz
 * @param belgeGit       (row, docKey) belge karesine tıklayınca
 * @param baslangicArama / baslangicSayfa / baslangicBoyut   #728: ilk açılan arama, sayfa ve sayfa boyutu (denetmen sayfası adres çubuğundan okur)
 * @param baslangicKaydirma  #728: kişi detayından dönüşte kaydırma konumu; liste ve kartların ayrıntısı yüklenince bir kez uygulanır
 * @param onDurum        #728: ({ sekme, alt, arama, sayfa, boyut }) => void — durum her değiştiğinde (üst sayfa adres çubuğuna yazar)
 * @param geriEtiketi    #728: kartın yeni sekmede açılan bağlantılarının "geri" yazısı (denetmen)
 */
export default function FirmaPersonelSekmeleri({
  firmaId, firmaAdi = null, firmaGorunenAdi = null, fuarId, taraf = "firma", yazabilir = true, yabanci = false, yabanciKatilimci = false,
  sadePanel = false,
  baslangicSekme = PERSONEL_SEKME.TUM, baslangicAltSekme = PERSONEL_ALT_SEKME.TUMU,
  baslangicArama = "", baslangicSayfa = 1, baslangicBoyut = VARSAYILAN_SAYFA_BOYUTU, baslangicKaydirma = null, onDurum = null, geriEtiketi = null,
  reloadToken = 0, detayOf, belgeGit,
}) {
  const { t: tx } = useTranslation("components");
  // #704: the sade LIST (tabs, row card, the "remove the assignment" words) = the real Yabancı Katılımcı or Sade panel modu; the documents
  // and the hidden staff-type picker stay the real Yabancı Katılımcı's (`yabanciKatilimci`).
  const sade = yabanciKatilimci || sadePanel;

  // #511: Yabancı Katılımcı'da Daimî / Geçici sekmeleri yok. Etkin arayüz seti sayfa açıkken başlıktan değişebilir; seçili sekme
  // görünenler arasında değilse Tüm Personeller'e düşülür (`?sekme=daimi` bağlantısı da böyle karşılanır).
  // WAS (until #704): const sekmeler = yabanciKatilimci ? SEKMELER.filter(sekmeGorunur) : SEKMELER;
  const sekmeler = sade ? SEKMELER.filter(sekmeGorunur) : SEKMELER;
  const [secilenSekme, setSecilenSekme] = useState(SEKMELER.some((s) => s.key === baslangicSekme) ? baslangicSekme : PERSONEL_SEKME.TUM);
  const sekme = sekmeler.some((s) => s.key === secilenSekme) ? secilenSekme : PERSONEL_SEKME.TUM;
  const [altSekme, setAltSekme] = useState(ALT_SEKMELER.some((s) => s.key === baslangicAltSekme) ? baslangicAltSekme : PERSONEL_ALT_SEKME.TUMU);
  const [aramaGirdi, setAramaGirdi] = useState(baslangicArama);
  const [arama, setArama] = useState(baslangicArama);
  const [sayfa, setSayfa] = useState(Math.max(1, Number(baslangicSayfa) || 1));
  // #728: sayfa boyutu yalnızca denetmen tarafında seçilir; firma portalı hep varsayılanı (10) kullanır.
  const [boyut, setBoyut] = useState(taraf === "denetmen" ? sayfaBoyutuCozumle(baslangicBoyut) : PAGE_SIZE);
  const [oncekiFuar, setOncekiFuar] = useState(fuarId);
  // Fuar değişince eski sayfa numarası yeni listede olmayabilir.
  if (oncekiFuar !== fuarId) {
    setOncekiFuar(fuarId);
    setSayfa(1);
  }

  const [veri, setVeri] = useState(BOS_VERI);
  // Tüm Personeller'in alt sekme sayıları: başka bir sekmedeyken `altSekmeler` O sekmeyi anlatır, bu yüzden son görülen saklanır.
  const [tumAlt, setTumAlt] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);
  const [flash, setFlash] = useState(null);
  const [yerelToken, setYerelToken] = useState(0);
  const [busy, setBusy] = useState(false);
  const [fotoYukleniyorId, setFotoYukleniyorId] = useState(null); // vesikalığı yüklenmekte olan kişi (#588)

  const [ekleModal, setEkleModal] = useState(false);
  const [sonlandirModal, setSonlandirModal] = useState(null);
  const [geriAlModal, setGeriAlModal] = useState(null);
  const [cikarModal, setCikarModal] = useState(null);
  const [redKayit, setRedKayit] = useState(null);
  const [kimlikKisi, setKimlikKisi] = useState(null);
  // #728: denetmen kartının üç penceresi (Kişi Listesi'ndekilerin aynısı) ve fuar adı / logosu için fuar listesi.
  const [kimlikDogrulaHedef, setKimlikDogrulaHedef] = useState(null);
  const [kartYazdirHedef, setKartYazdirHedef] = useState(null);
  const [meslekHedef, setMeslekHedef] = useState(null);
  const [fuarlar, setFuarlar] = useState([]);
  const getFairs = useContext(FairContext)?.getFairs;
  useEffect(() => {
    if (taraf !== "denetmen" || !getFairs) return undefined;
    let ignore = false;
    getFairs().then((res) => { if (!ignore) setFuarlar(res?.data || []); }).catch(() => {});
    return () => { ignore = true; };
  }, [taraf, getFairs]);
  const fuarKaydi = fuarlar.find((f) => Number(f.id) === Number(fuarId));
  const fuarAdi = fuarKaydi?.nameTR || (fuarId ? `Fuar ${fuarId}` : "");

  const sekmeMeta = SEKMELER.find((s) => s.key === sekme) ?? SEKMELER[0];
  const fuarli = Boolean(fuarId) && sekmeMeta.fuarli;
  // `altKullanilir`: istek alt sekme taşıyabilir. #511: Yabancı Katılımcı alt sekme ÇUBUĞU görmez (`altSekmeli`) — durum satırdaki rol
  // yazısından okunur; "Assigned Users" sekmesi alt sekmeyi (Fuar Kadrosu) kendisi seçer, eski `?alt=` bağlantıları Tümü'ne düşer.
  const altKullanilir = sekme === PERSONEL_SEKME.TUM && Boolean(fuarId);
  // WAS (until #704): altKullanilir && !yabanciKatilimci; and (yabanciKatilimci && altSekme !== ...) below
  const altSekmeli = altKullanilir && !sade;
  const etkinAlt = altKullanilir
    ? (sade && altSekme !== PERSONEL_ALT_SEKME.KADRO ? PERSONEL_ALT_SEKME.TUMU : altSekme)
    : PERSONEL_ALT_SEKME.TUMU;

  // Yeniden okuma bir sayaçla tetiklenir (effect gövdesinde doğrudan setState react-hooks/set-state-in-effect'i ihlal eder).
  useEffect(() => {
    if (!firmaId) return undefined;
    let ignore = false;
    async function run() {
      setYukleniyor(true);
      setHata(null);
      try {
        const out = await getFirmaPersonelSekme(firmaId, {
          sekme,
          altSekme: altKullanilir && etkinAlt !== PERSONEL_ALT_SEKME.TUMU ? etkinAlt : undefined,
          fuarId: fuarli ? fuarId : undefined,
          search: arama,
          page: sayfa,
          size: boyut,
        });
        if (ignore) return;
        // #728: adresten gelen sayfa veri azaldığı için artık yoksa son sayfaya in (boş "kimse yok" çıkmasın).
        if (out.total > 0 && sayfa > out.totalPages) { setSayfa(Math.max(1, out.totalPages)); return; }
        setVeri(out);
        if (sekme === PERSONEL_SEKME.TUM && out.sayilar?.altSekmeler) setTumAlt(out.sayilar.altSekmeler);
      } catch (e) {
        if (!ignore) {
          setHata(e.message);
          setVeri(BOS_VERI);
        }
      } finally {
        if (!ignore) setYukleniyor(false);
      }
    }
    run();
    return () => { ignore = true; };
  }, [firmaId, fuarId, fuarli, altKullanilir, sekme, etkinAlt, arama, sayfa, boyut, reloadToken, yerelToken]);

  // #728: liste durumu (sekme · alt sekme · arama · sayfa · boyut) üst sayfaya bildirilir; denetmen sayfası adres çubuğuna yazar ki kişi
  // detayından dönüşte hepsi yerinde dursun (Kişi Listesi'nin #262 davranışı). `onDurum` her çizimde yeni olabilir: ref'ten okunur.
  const onDurumRef = useRef(onDurum);
  useEffect(() => { onDurumRef.current = onDurum; });
  useEffect(() => {
    onDurumRef.current?.({ sekme, alt: altKullanilir ? altSekme : PERSONEL_ALT_SEKME.TUMU, arama, sayfa, boyut });
  }, [sekme, altKullanilir, altSekme, arama, sayfa, boyut]);

  // ── Kadro satırlarının belge/Eşleme ayrıntısı (sayfa başına, kişi başına, önbellekli) ──────────────────────
  const detayAnahtar = `${firmaId}|${fuarId || 0}|${reloadToken}|${yerelToken}`;
  const [detaylar, setDetaylar] = useState({ anahtar: null, harita: {} });
  const istenenRef = useRef({ anahtar: null, idler: new Set() });
  const guncelAnahtarRef = useRef(detayAnahtar);
  useEffect(() => { guncelAnahtarRef.current = detayAnahtar; }, [detayAnahtar]);

  const detayGerekenler = useMemo(
    () => (fuarId ? veri.records.filter(kadroSatiri).map((r) => r.personId) : []),
    [veri.records, fuarId],
  );

  useEffect(() => {
    if (!firmaId || !fuarId || detayGerekenler.length === 0) return;
    if (istenenRef.current.anahtar !== detayAnahtar) istenenRef.current = { anahtar: detayAnahtar, idler: new Set() };
    const eksik = detayGerekenler.filter((id) => !istenenRef.current.idler.has(id));
    if (eksik.length === 0) return;
    eksik.forEach((id) => istenenRef.current.idler.add(id));
    const anahtar = detayAnahtar;
    const yaz = (id, kayit) => setDetaylar((d) => ({
      anahtar, harita: { ...(d.anahtar === anahtar ? d.harita : {}), [id]: kayit },
    }));
    async function run() {
      const kuyruk = [...eksik];
      const isci = async () => {
        while (kuyruk.length > 0) {
          const id = kuyruk.shift();
          try {
            const dto = await getPersonelDetayAdmin(firmaId, id, fuarId);
            if (guncelAnahtarRef.current === anahtar) yaz(id, { durum: "hazir", dto });
          } catch {
            if (guncelAnahtarRef.current === anahtar) yaz(id, { durum: "hata" });
          }
        }
      };
      await Promise.all(Array.from({ length: Math.min(DETAY_PARALEL, eksik.length) }, isci));
    }
    run();
  }, [firmaId, fuarId, detayGerekenler, detayAnahtar]);

  const detayHaritasi = detaylar.anahtar === detayAnahtar ? detaylar.harita : {};

  // #728: kişi detayından dönüşte kaydırma konumu. Kartlar ayrıntı okumaları geldikçe uzar; önce liste VE tüm ayrıntılar (başarılı ya da hatalı)
  // gelsin, sonra bir kez kaydırılır. Ayrıntılardan biri takılırsa 5 sn sonra yine de kaydırılır.
  const bekleyenKaydirma = useRef(typeof baslangicKaydirma === "number" ? baslangicKaydirma : null);
  const kaydirmayiUygula = useCallback(() => {
    if (bekleyenKaydirma.current == null) return;
    const y = bekleyenKaydirma.current;
    bekleyenKaydirma.current = null;
    // html { scroll-behavior: smooth } (bootstrap) olduğu için "instant": dönüşte yukarıdan kayarak inmesin.
    requestAnimationFrame(() => window.scrollTo({ top: y, left: 0, behavior: "instant" }));
  }, []);
  const listeHazir = !yukleniyor && veri.records.length > 0;
  const detaylarTamam = detayGerekenler.every((id) => detayHaritasi[id]);
  useEffect(() => {
    if (listeHazir && detaylarTamam) kaydirmayiUygula();
  }, [listeHazir, detaylarTamam, kaydirmayiUygula]);
  useEffect(() => {
    if (!listeHazir || bekleyenKaydirma.current == null) return undefined;
    const zamanlayici = setTimeout(kaydirmayiUygula, 5000);
    return () => clearTimeout(zamanlayici);
  }, [listeHazir, kaydirmayiUygula]);

  // ── Sayılar ───────────────────────────────────────────────────────────────────────────────────────────
  const sayilar = veri.sayilar;
  const sekmeSayisi = (s) => {
    if (!sayilar) return null;
    // Fuar seçiliyken Tüm Personeller o fuarın listede olmayan kadrosunu da içerir; son görülen alt sekme toplamı onu sayar.
    if (s.key === PERSONEL_SEKME.TUM && fuarId && tumAlt) return tumAlt.tumu;
    return sayilar[s.say];
  };
  const altSayisi = (a) => {
    const kaynak = sekme === PERSONEL_SEKME.TUM ? (veri.sayilar?.altSekmeler ?? tumAlt) : tumAlt;
    return kaynak ? kaynak[a.say] : null;
  };

  function sekmeSec(key) {
    setSecilenSekme(key);
    setSayfa(1);
  }
  function altSec(key) {
    setAltSekme(key);
    setSayfa(1);
  }
  function aramaYap() {
    setArama(aramaGirdi);
    setSayfa(1);
  }
  const reload = () => setYerelToken((n) => n + 1);

  // Sekme çubuğunun öğeleri. Yabancı Katılımcı'nın üç sekmesi (sekme, alt sekme) çifti seçer; rozet sayıları aynı kaynaktan: Assigned Users =
  // son görülen alt sekme toplamının `kadro`su (yalnızca Tüm Personeller'i gezince bilinir), Ex-Employees = `sayilar.ilisigiKesilmis`.
  const ykSayisi = (s) => {
    if (!sayilar) return null;
    if (s.id === "atanan") return tumAlt ? tumAlt.kadro : null;
    if (s.id === "eski") return sayilar.ilisigiKesilmis;
    return fuarId && tumAlt ? tumAlt.tumu : sayilar.tum;
  };
  // WAS (until #704): const sekmeOgeleri = yabanciKatilimci
  const sekmeOgeleri = sade
    ? YK_SEKMELER.filter((s) => !s.fuarli || Boolean(fuarId)).map((s) => ({
      id: s.id, secili: s.sekme === sekme && s.alt === etkinAlt, label: tx(s.label), title: tx(s.title), sayi: ykSayisi(s),
      sec: () => { sekmeSec(s.sekme); altSec(s.alt); },
    }))
    : sekmeler.map((s) => ({
      id: s.key, secili: sekme === s.key, label: tx(`personelSekmeler.${s.label}`), title: tx(`personelSekmeler.${s.title}`),
      sayi: sekmeSayisi(s), sec: () => sekmeSec(s.key),
    }));

  // ── Eylemler ──────────────────────────────────────────────────────────────────────────────────────────
  const adOf = (row) => `${row.ad ?? ""} ${row.soyad ?? ""}`.trim()
    || `${detayHaritasi[row.personId]?.dto?.name ?? ""} ${detayHaritasi[row.personId]?.dto?.surname ?? ""}`.trim()
    || `#${row.personId}`;

  async function handleTip(row, tip) {
    setBusy(true);
    try {
      const etiket = tx(`personelSekmeler.${TIP_META[tipId(tip)].label}`);
      // #729: eski görevlendirmenin liste satırı yok (PATCH 404 verir) — seçilen tip kişiyi firmanın listesine ekler.
      if (row.kayitTuru === "ESKI_KAYIT" && tip != null) {
        const eklenen = await addToRoster(firmaId, row.personId, { calisanTipi: tip });
        if (!eklenen.already) {
          setFlash({ color: "success", text: tx("personelSekmeler.tipListeyeEklendi", { ad: adOf(row), tip: etiket }) });
          reload();
          return;
        }
        // Arada başka biri listeye eklemiş: satır artık var, tip PATCH ile yazılır.
      }
      const out = await setCalisanTipi(firmaId, row.personId, tip);
      setFlash({
        color: "success",
        text: tx(out.degisti === false ? "personelSekmeler.tipZatenOyle" : "personelSekmeler.tipIsaretlendi", { ad: adOf(row), tip: etiket }),
      });
      reload();
    } catch (e) {
      setFlash({ color: "danger", text: e.message });
    } finally {
      setBusy(false);
    }
  }

  async function handleGorevlendir(row) {
    if (!fuarId) {
      setFlash({ color: "warning", text: tx("personelSekmeler.onceUsttekiFuarSecicisindenBir") });
      return;
    }
    setBusy(true);
    try {
      await assignPersonToFirmaAdmin({ personId: row.personId, firmaId, meslekId: row.meslekId || 0 }, fuarId);
      // Görevlendirme kimlik doğrulamasını beklemez, ama kart bekler (backend #54) — doğrulanmamışsa bunu hemen söyleriz.
      // Backend'in `message`i Türkçe sabit olduğu için gösterilmez; her dilde yerelleştirilmiş metin kullanılır.
      const kimlikEksik = row.kimlikDogrulamaDurum != null && row.kimlikDogrulamaDurum !== 1;
      setFlash({
        color: kimlikEksik ? "warning" : "success",
        text: `${adOf(row)} · ${tx("personelSekmeler.gorevlendirmeKaydedildi")}`
          + (kimlikEksik ? tx("personelSekmeler.kisininKimlikDogrulamasiYapilmamisSgk") : ""),
      });
      reload();
    } catch (e) {
      // 409 = kişi listede aktif değil (arada çıkarılmış olabilir) — mesaj olduğu gibi.
      setFlash({ color: isRosterMissingError(e) ? "warning" : "danger", text: e.message });
    } finally {
      setBusy(false);
    }
  }

  /**
   * #588: firma portalı — satırın vesikalık kutusuna tıklayıp seçilen dosyayı kişinin fotoğrafı yapar (POST /personnel/{id}/fotograf; kimlik
   * belgesi DEĞİL). Başarıyı kutuya `true` döndürerek bildirir (kutu fotoğrafı hemen yeniden okur); listeyi de tazeleriz (fotografVar / logo).
   * 403 KIMLIK_DOGRULANMIS: arada SAKA doğrulamış → backend metni Türkçe sabit olduğu için `kod`dan çevrilir, satır kilitlensin diye liste tazelenir.
   */
  async function handleFoto(row, dosya) {
    if (!FOTO_TURLERI.test(dosya.type) && !FOTO_UZANTILARI.test(dosya.name)) {
      setFlash({ color: "danger", text: tx("personelSekmeler.fotoGecersizTip") });
      return false;
    }
    setFotoYukleniyorId(row.personId);
    try {
      await uploadKisiFotograf(row.personId, dosya);
      setFlash({ color: "success", text: tx("personelSekmeler.fotoGuncellendi", { ad: adOf(row) }) });
      reload();
      return true;
    } catch (e) {
      const kilitli = e.kod === "KIMLIK_DOGRULANMIS";
      setFlash({
        color: "danger",
        text: kilitli ? tx("personelSekmeler.fotoKimlikDogrulanmis") : e.status == null ? tx("personelSekmeler.fotoSunucuYanitVermedi") : e.message,
      });
      if (kilitli) reload();
      return false;
    } finally {
      setFotoYukleniyorId(null);
    }
  }

  async function handleSonlandir(sebep) {
    if (!sonlandirModal) return;
    setBusy(true);
    try {
      const message = await removeFromRoster(firmaId, sonlandirModal.personId, { sebep });
      setFlash({ color: "success", text: message || tx("personelSekmeler.iliskiSonlandirildi") });
      reload();
    } catch (e) {
      setFlash({ color: "danger", text: e.message });
    } finally {
      setSonlandirModal(null);
      setBusy(false);
    }
  }

  /** Sonlandırılmış ilişkiyi geri alır (backend #109). 400/403/404/409 mesajı Türkçe, olduğu gibi. */
  async function handleGeriAl(sebep) {
    if (!geriAlModal) return;
    setBusy(true);
    try {
      const message = await undoRosterEnding(firmaId, geriAlModal.personId, { sebep });
      setFlash({ color: "success", text: message || tx("personelSekmeler.iliskiGeriAlindi") });
      setGeriAlModal(null);
      reload();
    } catch (e) {
      // 409 = arada yeniden eklenmiş: satır artık güncel listede, pencereyi kapatıp listeyi tazeliyoruz.
      if (e.status === 409) { setGeriAlModal(null); reload(); }
      setFlash({ color: e.status === 409 ? "warning" : "danger", text: e.message });
    } finally {
      setBusy(false);
    }
  }

  /** Onayla (1) ya da Reddet (2, sebep zorunlu) — yalnızca firmanın kendi girişi (denetmen 403). */
  async function answer(row, durum, sebep) {
    setBusy(true);
    try {
      const message = await answerEslesme(firmaId, row.personId, fuarId, { durum, sebep });
      setFlash({ color: "success", text: message });
    } catch (e) {
      // 409: aynı anda başkası cevapladı — satır eskimiş, yeniden okuyalım.
      setFlash({ color: "danger", text: e.message });
    } finally {
      setRedKayit(null);
      setBusy(false);
      reload();
    }
  }

  /** Staff: kişiyi yalnızca bu fuarın kadrosundan çıkarır; firmanın listesindeki kaydı yerinde kalır. */
  async function handleFuardanCikar() {
    if (!cikarModal) return;
    setBusy(true);
    try {
      const message = await removeFromFuarCrew(cikarModal.personId, { fuarId, firmaId });
      setFlash({ color: "success", text: message });
      reload();
    } catch (e) {
      setFlash({ color: "danger", text: e.message });
    } finally {
      setCikarModal(null);
      setBusy(false);
    }
  }

  // Sonlandır / Geri Al pencereleri `{ad} {soyad}` yazar; adsız kayıtta boş kalmasın diye tam ad `ad`a konur.
  const modalSatiri = (row) => ({ ...row, ad: adOf(row), soyad: "" });

  const records = veri.records;
  const totalPages = Math.max(1, veri.totalPages || 1);
  const fuarBilgisi = sekme === PERSONEL_SEKME.ILISIGI_KESILMIS || sekme === PERSONEL_SEKME.TAM;
  const bosMesaj = sekme === PERSONEL_SEKME.TUM && !arama && etkinAlt === PERSONEL_ALT_SEKME.TUMU;

  return (
    <>
      {flash && <Alert fade={false} color={flash.color} toggle={() => setFlash(null)}>{flash.text}</Alert>}

      <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
        <Nav pills className="mb-0">
          {sekmeOgeleri.map((s) => (
            <NavItem key={s.id}>
              <NavLink
                href="#" className={s.secili ? "active" : ""} title={s.title}
                onClick={(e) => { e.preventDefault(); s.sec(); }}
              >
                {s.label}
                <Rozet secili={s.secili} sayi={s.sayi} />
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <div className="d-flex gap-2 ms-auto align-items-center">
          <div className="d-flex">
            <Input
              bsSize="sm" value={aramaGirdi} placeholder={tx("personelSekmeler.adSoyadAra")}
              onChange={(e) => setAramaGirdi(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") aramaYap(); }}
              style={{ minWidth: 200 }}
            />
            <Button size="sm" color="light" onClick={aramaYap}><Search size={14} /></Button>
          </div>
          <Button size="sm" color="light" onClick={reload} disabled={yukleniyor}><RefreshCw size={14} /></Button>
          {yazabilir && (
            <Button size="sm" color="green" disabled={!firmaId} onClick={() => setEkleModal(true)} data-tour="personel-ekle">
              <UserPlus size={14} className="me-1" />{tx("personelSekmeler.personelEkle")}
            </Button>
          )}
        </div>
      </div>

      {altSekmeli && (
        <Nav pills className="mb-3 nav-sm">
          {ALT_SEKMELER.map((a) => {
            const secili = etkinAlt === a.key;
            return (
              <NavItem key={a.key}>
                <NavLink
                  href="#" className={secili ? "active" : ""} title={a.title ? tx(`personelSekmeler.${a.title}`) : undefined}
                  onClick={(e) => { e.preventDefault(); altSec(a.key); }}
                >
                  {a.label ? tx(`personelSekmeler.${a.label}`) : tx("common:tumu")}
                  <Rozet secili={secili} sayi={altSayisi(a)} />
                </NavLink>
              </NavItem>
            );
          })}
        </Nav>
      )}

      {hata && <Alert fade={false} color="danger">{hata}</Alert>}

      {!hata && (yukleniyor && records.length === 0 ? (
        <div className="text-center py-5"><Spinner color="primary" /></div>
      ) : records.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <Info size={32} className="mb-2" />
          {bosMesaj ? (
            <>
              <div>{tx("personelSekmeler.personelListenizdeKimseYok")}</div>
              <div className="small mt-1">{tx("personelSekmeler.fuaraGorevlendirebilmekIcinOnceKisileri")}</div>
            </>
          ) : (
            <div>{tx("personelSekmeler.bosSekme")}</div>
          )}
        </div>
      ) : (
        <div style={yukleniyor ? { opacity: 0.6, pointerEvents: "none" } : undefined}>
          {records.map((row) => {
            const detayYolu = detayOf?.(row) ?? null;
            return (
            <PersonelSekmeKarti
              key={`${row.personId}-${row.rosterId ?? "x"}`}
              row={row} taraf={taraf} yazabilir={yazabilir} yabanci={yabanci} yabanciKatilimci={yabanciKatilimci} sade={sade}
              firmaGorunenAdi={firmaGorunenAdi} fuarId={fuarId}
              fuarBilgisi={fuarBilgisi}
              detay={detayHaritasi[row.personId]}
              busy={busy} iliskiSonlandirabilir={veri.iliskiSonlandirabilir}
              adBaglantisi={detayYolu}
              detayAcik={Boolean(detayYolu)}
              onDetay={(r) => detayOf?.(r)?.onGit()}
              onBelge={(r, key) => belgeGit?.(r, key)}
              onKimlik={(r, dto) => setKimlikKisi({ personId: r.personId, name: adOf(r), belge: dto?.documents?.kimlikFotografi })}
              fotoYukleniyor={fotoYukleniyorId === row.personId} onFoto={handleFoto}
              onTip={handleTip} onGorevlendir={handleGorevlendir}
              onSonlandir={(r) => setSonlandirModal(modalSatiri(r))} onGeriAl={(r) => setGeriAlModal(modalSatiri(r))}
              onOnayla={(r) => answer(r, 1)} onReddet={setRedKayit} onFuardanCikar={setCikarModal}
              firmaId={firmaId} firmaAdi={firmaAdi} geriEtiketi={geriEtiketi}
              onKimlikDogrula={setKimlikDogrulaHedef} onKartYazdir={setKartYazdirHedef} onMeslek={setMeslekHedef}
            />
            );
          })}
        </div>
      ))}

      {!hata && records.length > 0 && (
        <>
          {totalPages > 1 && (
            <Pagination className="mt-3 mb-0 justify-content-end">
              <PaginationItem disabled={sayfa <= 1}>
                <PaginationLink previous onClick={() => setSayfa((p) => Math.max(1, p - 1))} />
              </PaginationItem>
              <PaginationItem disabled><PaginationLink>{sayfa} / {totalPages}</PaginationLink></PaginationItem>
              <PaginationItem disabled={sayfa >= totalPages}>
                <PaginationLink next onClick={() => setSayfa((p) => Math.min(totalPages, p + 1))} />
              </PaginationItem>
            </Pagination>
          )}
          <div className="text-center text-muted small p-3 d-flex align-items-center justify-content-center gap-3 flex-wrap">
            <span>{tx("personelSekmeler.sayfaToplam", { sayfa, toplam: totalPages, adet: veri.total })}</span>
            {/* #728: sayfa başına kişi (yalnızca denetmen); değişince 1. sayfaya dönülür. */}
            {taraf === "denetmen" && <SayfaBoyutuSecici value={boyut} onChange={(n) => { setBoyut(n); setSayfa(1); }} />}
          </div>
        </>
      )}

      {redKayit && (
        <EslesmeRedModal
          adSoyad={adOf(redKayit)} busy={busy}
          onClose={() => setRedKayit(null)}
          onConfirm={(sebep) => answer(redKayit, 2, sebep)}
        />
      )}

      {ekleModal && (
        <PersonelEkleModal
          firma={{ firmaId, firmaName: firmaAdi }}
          // #589: portalda "Kişiyi fuara görevlendir" anahtarı ve altındaki her şey (fuar bağı kontrolü, meslek) yok —
          // modal yalnızca kişiyi firmanın listesine ekler; fuara atama satırdaki "Fuara Görevlendir"le, meslek kişi sayfasından.
          // fuarId verilmezse modal bunları çizmez. SAKA tarafı (taraf="denetmen") anahtarı korur.
          // WAS (until #589): fuarId={fuarId}
          fuarId={taraf === "firma" ? null : fuarId}
          // #704: NOT `sade`: a Yerli company in Sade panel modu still says Daimî / Geçici (its SGK documents depend on it)
          calisanTipiGizli={yabanciKatilimci}
          onClose={() => setEkleModal(false)}
          // Modal sonuç ekranında açık KALIR (kimlik doğrulamayı öneriyor); liste arkada yenilenir.
          onDone={reload}
        />
      )}

      {kimlikKisi && (
        <KimlikPasaportModal
          kisi={{ personId: kimlikKisi.personId, name: kimlikKisi.name }}
          belge={kimlikKisi.belge}
          fuarId={fuarId}
          onClose={() => setKimlikKisi(null)}
          onSaved={reload}
        />
      )}

      {/* #728: denetmen kartının pencereleri — Kişi Listesi'ndekilerle aynı bileşenler, aynı bağlamda (bu firma, bu fuar). */}
      {kimlikDogrulaHedef && (
        <KimlikDogrulamaModal
          person={kimlikDogrulaHedef}
          fuarAdi={fuarId ? fuarAdi : null}
          fuarLogoUrl={fuarKaydi?.logoUrl ?? null}
          firmaFiltreId={firmaId}
          onClose={() => setKimlikDogrulaHedef(null)}
          onSaved={() => { setKimlikDogrulaHedef(null); reload(); }}
          onFotoDegisti={reload}
        />
      )}

      {kartYazdirHedef && fuarId && (
        <KartYazdirModal
          person={kartYazdirHedef}
          fuarId={fuarId}
          fuarAdi={fuarAdi}
          fuarLogoUrl={fuarKaydi?.logoUrl ?? null}
          baslangicFirmaId={firmaId}
          // Bu liste tek firmanın listesi: karar yalnızca o firmanındır (Kişi Listesi'nde firma süzgeci açıkken olduğu gibi, #400).
          firmaSabitId={firmaId}
          onClose={() => setKartYazdirHedef(null)}
          onKimlikSaved={reload}
          onFotoDegisti={reload}
        />
      )}

      {meslekHedef && (
        <MeslekDuzenleModal
          person={meslekHedef}
          onClose={() => setMeslekHedef(null)}
          onSaved={() => { setMeslekHedef(null); reload(); }}
        />
      )}

      <IliskiSonlandirModal
        row={sonlandirModal} busy={busy}
        onClose={() => !busy && setSonlandirModal(null)}
        onConfirm={handleSonlandir}
      />
      <IliskiGeriAlModal
        row={geriAlModal} busy={busy}
        onClose={() => !busy && setGeriAlModal(null)}
        onConfirm={handleGeriAl}
      />

      {/* Fuardan çıkarma (staff: "Fuardan Çıkar"; Yabancı Katılımcı firması: "Görevlendirmeyi Kaldır") — "İlişkiyi Sonlandır"dan AYRI bir iş;
          yalnızca bu fuarın kaydını kaldırır. İkisi de aynı uç (DELETE /personnel/sil/{id}?fuarId&firmaId), yalnızca sözcükler farklı. */}
      <Modal isOpen={!!cikarModal} toggle={() => !busy && setCikarModal(null)}>
        <ModalHeader toggle={() => !busy && setCikarModal(null)}>
          {/* WAS (until #704): yabanciKatilimci ? ... here and in the two texts below: the sade card's button opens this window */}
          {sade ? tx("rosterEylemleri.gorevKaldirBaslik") : tx("personelSekmeler.fuardanCikarBaslik")}
        </ModalHeader>
        <ModalBody>
          {cikarModal && (
            <>
              <p>
                <strong>{adOf(cikarModal)}</strong>{" "}
                {sade ? tx("rosterEylemleri.gorevKaldirMetin") : tx("personelSekmeler.fuardanCikarMetin")}
              </p>
              <Alert fade={false} color="warning" className="small mb-0 d-flex gap-2">
                <AlertTriangle size={18} className="flex-shrink-0 mt-1" />
                <div>{tx("personelSekmeler.fuardanCikarUyari")}</div>
              </Alert>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setCikarModal(null)} disabled={busy}>{tx("personelSekmeler.vazgec")}</Button>
          <Button color="danger" onClick={handleFuardanCikar} disabled={busy}>
            {busy ? <Spinner size="sm" /> : tx(sade ? "rosterEylemleri.gorevlendirmeyiKaldir" : "personelSekmeler.fuardanCikar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
